import { WindowType } from '../../types/global-window-type';
import { eventBus } from '../app-utils/event-bus';
import { initiateOHChat } from '../app-utils/page-specific-utils';
import { hideFloatingButton, updateButtonUnreadCount } from '../button-utils/custom-button-utils';

declare const window: WindowType;

export const launchChat = () => {
  if (window.embeddedservice_bootstrap && window?.isMiawChatReady === true) {
    window?.embeddedservice_bootstrap?.utilAPI
      ?.launchChat()
      ?.then(() => {
        const embeddedContainer = document.querySelector('.embeddedMessagingFrame');
        if (window.isChatMinimized) {
          if (embeddedContainer instanceof HTMLElement) {
            embeddedContainer.style.display = 'block';
          }
          window.isChatMinimized = false;
          sessionStorage.setItem('MessageCountWhenMinimized', '0');
          updateButtonUnreadCount('', false);
        } else {
          if (embeddedContainer instanceof HTMLElement) {
            embeddedContainer.style.maxHeight = '572px';
            embeddedContainer.style.height = '90%';
          }
          hideFloatingButton();
          delete window.isChatNowClicked;
        }
      })
      ?.catch((e) => {
        console.error('Error', e);
      });
  } else {
    window.isChatNowClicked = true;
  }
};

export const addOpenChatEventListener = () => {
  /** For Help Panel */
  eventBus.on('HPOpenChat', () => launchChat());
  eventBus.on('onCAButtonClicked', () => launchChat());
  eventBus.on('initCAfromExternalSource', () => launchChat());
  eventBus.on('OHOpenChat', (data) => initiateOHChat(data));
};
